const API_BASE = '/api'
const TOKEN_KEY = 'truco_token'

export async function apiRequest(method, path, body = null, requiresAuth = true) {
  const opts = {
    method,
    headers: { 'Content-Type': 'application/json' },
  }

  if (requiresAuth) {
    const token = localStorage.getItem(TOKEN_KEY)
    if (token) {
      opts.headers['Authorization'] = `Bearer ${token}`
    }
  }

  if (body) {
    opts.body = JSON.stringify(body)
  }

  const response = await fetch(`${API_BASE}${path}`, opts)

  if (response.status === 401) {
    localStorage.removeItem(TOKEN_KEY)
    throw new Error('Sessão expirada. Faça login novamente.')
  }

  const data = await response.json().catch(() => null)

  if (!response.ok) {
    const msg = data?.detail || data?.message || `Erro ${response.status}`
    throw new Error(msg)
  }

  return data
}
